import { Box, Grid, GridItem, Text, Image, Button, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Flex, Divider, } from '@chakra-ui/react'
import CalendarLogo from '../../../assets/images/CalendarLogo.svg'
import PlusIcon from '../../../assets/images/Vector.svg'
import MyDiv from './holiday.style'
import HolidayCalendar from '../components/HolidayCalendar'
import HolidayCard from '../components/HolidayCard'
import { useEffect, useState } from 'react'
import { useFetch } from '../../../hooks/useFetch'
import { CustomToast } from '../../../components'
import { HolidayResponse } from './modal'

const Holiday = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [data, setData] = useState<HolidayResponse | null>(null);

  useEffect(() => {
    Holiday()
  }, [])

  const Holiday = async () => {
    const response = await fetchApi("Hrlense_Holiday/AdminHoliday", "GET", null, "", "");
    if (response) {
      setData(response);
    }
  }

  return (
    <MyDiv>
      <Box className="page_wrapper ">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_3xl text_semibold">Holidays</Text>
          <Button className="font-poppins text_medium text_md btn_theme" onClick={onOpen} rightIcon={<Image src={PlusIcon} />}>Add Holiday</Button>
        </Flex>
      </Box>
      <Box >
        <Grid className='grid_container' gap={5} >
          <GridItem colSpan={4} >
            <Image src={CalendarLogo} alt="Calender Logo" height="auto" />
            <Box mt={5} ml={5} mr={10}>
              {/* <Flex alignItems="center" columnGap={2} mb={1}>
                <Box boxSize={2.5} bg="#006838" borderRadius="50%" />
                <Text className="font-poppins text_medium text_md">Today's Holiday</Text>
              </Flex> */}

              {/* <Box className="font-poppins text_medium text_md common_bg" p={4} textAlign="left" borderRadius="md" h="76px">
                <Flex columnGap={3}>
                  <Text>{data?.todayDay}.</Text>
                  <Text>{data?.todayDate}</Text>
                </Flex>
                <Text fontSize="md" className='common_color text_medium text_lg font-poppins'>{data?.todayHoliday}</Text>
              </Box> */}

              {/* <Divider my={4} borderColor="gray.300" /> */}

              <Flex alignItems="center" columnGap={2} mb={1}>
                <Box boxSize={2.5} bg="#50B8E4" borderRadius="50%" />
                <Text className="font-poppins text_medium text_md">Upcoming Holiday</Text>
              </Flex>

              {data && data.upcomingHolidays && data.upcomingHolidays.length > 0 && (
                <Box className="font-poppins text_medium text_md common_bg" p={4} textAlign="left" borderRadius="md" h="76px">
                  <Flex columnGap={3}>
                    <Text>{new Date(data.upcomingHolidays[0].holiday_Date).toLocaleDateString('en-US', { weekday: 'long' })}.</Text>
                    <Text>{new Date(data.upcomingHolidays[0].holiday_Date).toLocaleDateString('en-GB')}</Text>
                  </Flex>
                  <Text fontSize="md" className='common_color text_medium text_lg font-poppins'>{data.upcomingHolidays[0].holiday_Name}</Text>
                </Box>
              )}
            </Box>

          </GridItem>
          <GridItem colSpan={8} w={'auto'}>
            <HolidayCalendar />
          </GridItem>
        </Grid>
      </Box>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
        <DrawerOverlay />
        <DrawerContent className='drawer' display="flex" flexDirection="column" height="100%">
          <DrawerCloseButton />
          <DrawerHeader>Add Holiday</DrawerHeader>
          <DrawerBody pb="70px" flex={1} overflow="auto">
            <HolidayCard onclose={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MyDiv>
  )
}

export default Holiday

